(function () {
  if (customElements.get('cart-progress')) return;

  // Mirrors Shopify's money filter so the bar can relabel itself after a cart
  // change without a round trip to the server for formatting.
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    if (!format) return withDelimiters(cents, 2, ',', '.');

    var match = format.match(placeholder);
    var key = match ? match[1] : 'amount';
    var value;

    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return format.replace(placeholder, value);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#39;');
  }

  function onCartPage() {
    return window.location.pathname.indexOf('/cart') !== -1;
  }

  var MAX_PICKS = 3;

  class CartProgress extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-cart-progress-message]');
      this.trackEl = this.querySelector('[data-cart-progress-track]');
      this.fillEl = this.querySelector('[data-cart-progress-fill]');
      this.suggestionsEl = this.querySelector('[data-cart-progress-suggestions]');

      this.goals = this.parseJson(this.dataset.goals, []);
      this.goals.sort(function (a, b) {
        return a.amount - b.amount;
      });

      var fillerScript = this.querySelector('[data-cart-progress-fillers]');
      this.fillers = fillerScript ? this.parseJson(fillerScript.textContent, []) : [];
      this.shippingFee = parseInt(this.dataset.shippingFee || '0', 10) || 0;

      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleClick = this.handleClick.bind(this);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
      }
      document.addEventListener('cart-progress:refresh', this.handleCartUpdate);
      if (this.suggestionsEl) this.suggestionsEl.addEventListener('click', this.handleClick);

      // The bar itself is server rendered; the suggestions need the live cart
      // so we know what is already in it.
      if (this.fillers.length) this.refresh();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('cart-progress:refresh', this.handleCartUpdate);
      if (this.suggestionsEl) this.suggestionsEl.removeEventListener('click', this.handleClick);
    }

    parseJson(raw, fallback) {
      try {
        var parsed = JSON.parse(raw || '');
        return parsed || fallback;
      } catch (error) {
        return fallback;
      }
    }

    cartUrl() {
      return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    }

    handleCartUpdate() {
      this.refresh();
    }

    refresh() {
      var self = this;
      return fetch(this.cartUrl() + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          self.render(cart);
        })
        .catch(function () {
          /* Leave the server-rendered state in place. */
        });
    }

    render(cart) {
      if (!this.goals.length) return;
      var totalCents = cart.total_price;

      var goal = null;
      for (var i = 0; i < this.goals.length; i++) {
        if (totalCents < this.goals[i].amount) {
          goal = this.goals[i];
          break;
        }
      }

      var isComplete = goal === null;
      if (isComplete) goal = this.goals[this.goals.length - 1];
      if (!goal || !goal.amount) return;

      var remaining = Math.max(goal.amount - totalCents, 0);
      var percent = Math.min(Math.floor((totalCents * 100) / goal.amount), 100);

      var template = isComplete ? this.dataset.messageComplete : this.dataset.messagePending;
      var message = (template || '')
        .replace('[amount]', formatMoney(remaining, this.dataset.moneyFormat))
        .replace('[reward]', goal.reward);

      if (this.messageEl) this.messageEl.textContent = message;
      if (this.fillEl) this.fillEl.style.width = percent + '%';
      if (this.trackEl) {
        this.trackEl.setAttribute('aria-valuenow', percent);
        this.trackEl.setAttribute('aria-label', message);
      }
      this.classList.toggle('cart-progress--complete', isComplete);

      this.renderSuggestions(remaining, cart);
    }

    // Cheapest thing that actually closes the gap comes first, so the customer
    // is never pushed to overspend more than they have to. Anything that would
    // not close it only appears to fill out the row.
    pick(gap, cart) {
      var inCart = {};
      (cart.items || []).forEach(function (item) {
        inCart[item.variant_id] = true;
      });

      var closes = [];
      var falls = [];
      this.fillers.forEach(function (filler) {
        if (inCart[filler.id]) return;
        if (filler.price >= gap) closes.push(filler);
        else falls.push(filler);
      });

      closes.sort(function (a, b) { return a.price - b.price; });
      falls.sort(function (a, b) { return b.price - a.price; });

      var picks = closes.slice(0, MAX_PICKS);
      if (picks.length < MAX_PICKS) {
        picks = picks.concat(falls.slice(0, MAX_PICKS - picks.length));
      }
      return { picks: picks, cheapestCloser: closes.length ? closes[0] : null };
    }

    renderSuggestions(gap, cart) {
      if (!this.suggestionsEl || !this.fillers.length) return;

      if (gap <= 0) {
        this.suggestionsEl.hidden = true;
        this.suggestionsEl.innerHTML = '';
        return;
      }

      var result = this.pick(gap, cart);
      if (!result.picks.length) {
        this.suggestionsEl.hidden = true;
        this.suggestionsEl.innerHTML = '';
        return;
      }

      var format = this.dataset.moneyFormat;
      var fee = this.shippingFee;
      var heading = this.dataset.suggestionsHeading || '';

      // When the cheapest qualifying add-on costs less than the shipping it
      // cancels, say so plainly — it is simply the better deal.
      var cheapest = result.cheapestCloser;
      if (cheapest && fee > 0 && cheapest.price <= fee) {
        heading = 'Add one of these — it costs less than the ' + formatMoney(fee, format) + ' shipping';
      }

      var items = result.picks.map(function (filler) {
        var closes = filler.price >= gap;
        var note = '';

        if (closes && fee > 0) {
          var net = filler.price - fee;
          note = net <= 0
            ? 'Cheaper than paying shipping'
            : 'Really ' + formatMoney(net, format) + ' once shipping is free';
        } else if (!closes) {
          note = formatMoney(gap - filler.price, format) + ' still to go';
        }

        var url = escapeHtml(filler.url);
        var media = filler.image
          ? '<img class="cart-progress__pick-image" src="' + escapeHtml(filler.image) + '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="cart-progress__pick-image cart-progress__pick-image--empty" aria-hidden="true"></span>';

        return '<li class="cart-progress__pick' + (closes ? ' cart-progress__pick--closes' : '') + '">' +
          '<a class="cart-progress__pick-link" href="' + url + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
          '<span class="cart-progress__pick-body">' +
            '<a class="cart-progress__pick-title" href="' + url + '">' + escapeHtml(filler.title) + '</a>' +
            '<span class="cart-progress__pick-price">' + formatMoney(filler.price, format) + '</span>' +
            (note ? '<span class="cart-progress__pick-note">' + escapeHtml(note) + '</span>' : '') +
          '</span>' +
          '<button type="button" class="cart-progress__pick-add" data-add-filler="' + filler.id + '">Add</button>' +
        '</li>';
      }).join('');

      this.suggestionsEl.innerHTML =
        '<p class="cart-progress__suggestions-heading">' + escapeHtml(heading) + '</p>' +
        '<ul class="cart-progress__picks" role="list">' + items + '</ul>';
      this.suggestionsEl.hidden = false;
    }

    handleClick(event) {
      var button = event.target.closest('[data-add-filler]');
      if (!button) return;
      event.preventDefault();

      var variantId = button.getAttribute('data-add-filler');
      if (!variantId || button.disabled) return;

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          // The cart page renders its line items server side, so a reload is
          // the one way to be certain the customer sees what they now have.
          if (onCartPage()) {
            window.location.reload();
            return null;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-progress' });
          }
          return self.refresh();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = original;
        });
    }
  }

  customElements.define('cart-progress', CartProgress);
})();